import { useMutation } from "react-query";

import api from "../../../api";

const resetPasswordService = async ({ resetPasswordData }) => {
  const { data } = await api.post("/auth/password/reset", {
    ...resetPasswordData,
  });
  return data;
};

export const useResetPasswordMutation = ({ onSuccess }) => {
  const [mutate, { status, error, isLoading }] = useMutation(
    resetPasswordService,
    {
      onSuccess,
    },
  );

  return {
    mutate,
    status,
    error,
    isLoading,
  };
};
